var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: {
            title: _vm.$t("details"),
            visible: _vm.dialogShow,
            modal: false,
            "modal-append-to-body": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: { "label-position": "left", "label-width": "120px" }
            },
            _vm._l(_vm.main_content, function(domain, index) {
              return _c(
                "div",
                { key: index + "k", staticClass: "main_contentClass" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "lodingItem-operationFrame flex",
                      staticStyle: { "margin-bottom": "20px" }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "lodingItem contentValitemt",
                          attrs: {
                            prop: "main_content." + index + ".title",
                            label: _vm.$t("title"),
                            "label-width": "60px"
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "operationFrame-entity",
                            attrs: {
                              disabled: true,
                              clearable: "",
                              placeholder: _vm.$t("pleaseInputTitle")
                            },
                            model: {
                              value: domain.title,
                              callback: function($$v) {
                                _vm.$set(domain, "title", $$v)
                              },
                              expression: "domain.title"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "lodingItem contentValitemt",
                          staticStyle: { "margin-left": "20px" },
                          attrs: {
                            prop: "main_content." + index + ".language",
                            label: _vm.$t("language"),
                            "label-width": "60px"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "flex-1",
                              attrs: {
                                disabled: true,
                                clearable: "",
                                filterable: "",
                                placeholder: _vm.$t("pleaseChoose")
                              },
                              model: {
                                value: domain.language,
                                callback: function($$v) {
                                  _vm.$set(domain, "language", $$v)
                                },
                                expression: "domain.language"
                              }
                            },
                            _vm._l(_vm.langList, function(item) {
                              return _c("el-option", {
                                key: item.label,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "flex lodingItem-title first_box",
                      staticStyle: {
                        "margin-bottom": "20px",
                        width: "100%",
                        "align-items": "center"
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("emailContent")) + ": ")]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { prop: "main_content." + index + ".content" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 2, maxRows: 12 },
                          disabled: true,
                          placeholder: _vm.$t("pleaseInputContent")
                        },
                        model: {
                          value: domain.content,
                          callback: function($$v) {
                            _vm.$set(domain, "content", $$v)
                          },
                          expression: "domain.content "
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }),
            0
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: {
                    click: function($event) {
                      _vm.dialogShow = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("confirm")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }